import React, { Component } from 'react';
import { DatePicker, Select, message, Dropdown, Table } from 'antd';
import { map } from 'lodash';
import Loader from '../../../Common/Component/Loader';
import moment from 'moment-timezone';
import DataTable from './Datatable';
import {errorHandle} from "../../../Common/errorHandle";
const { RangePicker } = DatePicker;
const { Option } = Select;

class AccountAgingSummary extends Component {
  state = {
    curr_id: '',
    customerList: [],
    franchiseList: [],
    agging_summary: [],
    selectedRowKeys: [],
    agging_list_pagination: { current: 1, showSizeChanger: false, pageSize: 15, ordering: "", },
    active_pagination: '15',
    set_table_active_action: '',
    assigne_list_filter: {},
    loader: false,
    search_value: ''
  }

  componentDidMount = () => {
    this.setState({
      loader: true
    })
    //List of customer
    this.props.getCustomers({ limit: 10, offset: 0 });
    //Get Franchise List
    this.props.getFranchiseList({ limit: 15, offset: 0 });
    //Get Agging Summary
    this.props.getAccountAggingSummary({ limit: 15, offset: 0 })
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let { agging_list_pagination } = this.state;

    //Get Customer List
    if (Object.keys(props.CustomerList.customerList).length > 0 && props.CustomerList.customerList !== this.props.CustomerList.customerList) {
      this.setState({
        customerList: props.CustomerList.customerList.results,
        loader: false
      })
    }
    if (Object.keys(props.CustomerList.errors).length > 0 && props.CustomerList.errors !== this.props.CustomerList.errors) {
      errorHandle(props.CustomerList.errors)
      this.setState({loader: false});
    }
    //get franchise list
    if (Object.keys(props.FranchiseList.data).length > 0 && props.FranchiseList.data !== this.props.FranchiseList.data) {
      this.setState({
        franchiseList: props.FranchiseList.data.results,
        loader: false
      })
    }
    if (Object.keys(props.FranchiseList.errors).length > 0 && props.FranchiseList.errors !== this.props.FranchiseList.errors) {
      // display error messsage
      errorHandle(props.FranchiseList.errors);
      this.setState({ loader: false });
    }
    //get aggginAList
    if (Object.keys(props.AggingSummary.data).length > 0 &&
      props.AggingSummary.data !== this.props.AggingSummary.data) {
      agging_list_pagination.total = props.AggingSummary.data.count;
      this.setState({
        agging_summary: props.AggingSummary.data.results,
        agging_list_pagination,
        loader: false,
        curr_id: '',
        set_table_active_action: ''
      });
    }
    if (Object.keys(props.AggingSummary.errors).length > 0 && 
      props.AggingSummary.errors !== this.props.AggingSummary.errors) {
      // display error messsage
      errorHandle(props.AggingSummary.errors)
      this.setState({
        loader: false,
        curr_id: '',
        set_table_active_action: ''
      })
    }
    if (Object.keys(props.GetSuspend.data).length > 0 && 
      props.GetSuspend.data !== this.props.GetSuspend.data) {
      //Get Agging Summary
      // this.props.getAccountAggingSummary({ limit: 15, offset: 0 });
      message.success(props?.GetSuspend?.data?.message)
    }
    if (Object.keys(props.AggingSummary.errors).length > 0 && 
      props.AggingSummary.errors !== this.props.AggingSummary.errors) {
      // display error messsage
      errorHandle(props.AggingSummary.errors)
      this.setState({ loader: false })
    }
    //Print Invoice
    if (Object.keys(props.PrintedInvoice.data).length > 0 &&
      props.PrintedInvoice.data !== this.props.PrintedInvoice.data) {
      //Print Invoice
      this.setState({
        loader: false,
        selectedRowKeys: [],
        set_table_active_action: '',
        curr_id: '',
      });

      var byteCharacters = atob(props?.PrintedInvoice?.data?.data);
      var byteNumbers = new Array(byteCharacters.length);

      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
    if (Object.keys(props.PrintedInvoice.errors).length > 0 &&
      props.PrintedInvoice.errors !== this.props.PrintedInvoice.errors) {
      errorHandle(props.PrintedInvoice.errors);

      this.setState({
        loader: false,
        set_table_active_action: '',
        curr_id: '',
      });
    }

    //Send Reminder
    if (Object.keys(props.SendInvoiceReminder.data).length > 0 &&
      props.SendInvoiceReminder.data !== this.props.SendInvoiceReminder.data) {
      //Print Invoice
      this.setState({
        loader: false,
        selectedRowKeys: [],
        set_table_active_action: ''
      });

      message.success(props?.SendInvoiceReminder?.data?.message, 10);
    }

    if (Object.keys(props.SendInvoiceReminder.errors).length > 0 && 
      props.SendInvoiceReminder.errors !== this.props.SendInvoiceReminder.errors) {
      
      errorHandle(props.SendInvoiceReminder.errors);

      this.setState({
        loader: false,
        set_table_active_action: ''
      });
    }

    this.setState({loader: false});
  }

  // on search
  onSearch = (e) => {
    const search_value = e.target.value;

    if (search_value?.length >= 3 || search_value?.length === 0) {
      this.props.getAccountAggingSummary({ 'search': search_value, limit: 15, offset: 0 })
    }

    this.setState({search_value: search_value});
  }

  //Set page limit
  setMessagePageLimit = (custom_limit) => {
    let { search_value, agging_list_pagination, expired_list_filter } = this.state;
    agging_list_pagination = Object.assign(agging_list_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      agging_list_pagination,
      loader: true,
      active_pagination: custom_limit,
    })

    let data = {
      offset: 0, 
      limit: custom_limit,
      search: search_value, 
      ...expired_list_filter
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAccountAggingSummary(data);
  }

  //Selct Table Row checkbox
  onSelectedRowKeysChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  }

  agingTableFilter = (pagination) => {
    let {
      agging_list_pagination,
      active_pagination,
      search_value,
      assigne_list_filter 
    } = this.state;

    agging_list_pagination = Object.assign(agging_list_pagination, { 'current': pagination.current });

    this.setState({
      agging_list_pagination,
      loader: true
    })

    let data = {
      offset: (pagination.current * 10) - 10,
      limit: active_pagination,
      ...assigne_list_filter,
      search: search_value,
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAccountAggingSummary(data)
  }

  //Render Agging Summary Table
  renderAggingSummaryTable = () => {
    let {
      agging_summary,
      agging_list_pagination,
      active_pagination,
      selectedRowKeys 
    } = this.state;

    return (
      <React.Fragment>
        <Table
          rowKey={record => record?.user?.uuid}
          dataSource={agging_summary}
          pagination={agging_list_pagination}
          onChange={this.agingTableFilter}
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys,
            onChange: this.onSelectedRowKeysChange
          }}
          columns={DataTable.AllAgginSummaryList(this)} />
        {agging_summary.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setMessagePageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setMessagePageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setMessagePageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </React.Fragment>
    )
  }

  //Date Range Change
  onInvoiceDateRange = (e) => {
    let { assigne_list_filter, active_pagination } = this.state;

    if (e) {
      assigne_list_filter = Object.assign(assigne_list_filter, {
        invoice_date__lte: moment(e[1]).format('YYYY-MM-DD'),
        invoice_date__gte: moment(e[0]).format('YYYY-MM-DD'),
      })
    }
    else {
      assigne_list_filter = Object.assign(assigne_list_filter, {
        invoice_date__lte: '',
        invoice_date__gte: '',
      })
    }
    this.setState({assigne_list_filter});
    
    let data = {
      offset: 0, 
      limit: active_pagination, 
      ...assigne_list_filter
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    //Call API
    this.props.getAccountAggingSummary(data);
  }

  //Customer and Status Change
  customerAndStatusOnChange = (e, type) => {
    let { assigne_list_filter, active_pagination } = this.state;
    assigne_list_filter = Object.assign(assigne_list_filter, { [type]: e });


    this.setState({
      assigne_list_filter,
      loader: true
    })

    let data = {
      offset: 0,
      limit: active_pagination,
      ...assigne_list_filter
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    //Call API
    this.props.getAccountAggingSummary(data);
  }

  render() {
    let { customerList, franchiseList, loader, assigne_list_filter, selectedRowKeys } = this.state;
    const menu = (
      <div className="table_inner_filter_select">
        <ul>
          {/* <li onClick={() => {
            if (selectedRowKeys.length > 0) {
              this.setState({ loader: true });
              this.props.printInvoice({ multiple_invoices_uuid: selectedRowKeys.join(',') })
            }
          }}>Print Invoices</li> */}
          <li onClick={() => {

            if (selectedRowKeys.length > 0) {
              this.setState({ loader: true });
              this.props.sendInvoiceReminder({ multiple_invoices_uuid: selectedRowKeys.join(',') })
            }
          }}>Send Reminders</li>
        </ul>
      </div>
    )
    return (
      <div className="account_expired_card">

        <div className="filter_wrapper flex">
          <div className="form-group flex ai-center fltr-txt">
            <div className="fitem">
              <RangePicker
                format={'MM/DD/YYYY'}
                className="date_ranger dwhite"
                dropdownClassName="dropdown_date_range"
                suffixIcon={<i className="las la-angle-down"></i>}
                onChange={(e) => { this.onInvoiceDateRange(e) }}
                inputReadOnly
              />
            </div>

            <div className="fitem">
              <RangePicker
                format={'MMM YYYY'}
                className="due_ranger dwhite"
                dropdownClassName="dropdown_date_range"
                suffixIcon={<i className="las la-angle-down"></i>}
                onChange={(e) => { this.onInvoiceDateRange(e) }}
                inputReadOnly
              />
            </div>
            <div className="fitem">
              <Select
                style={{ 'width': '150px' }}
                className=" swhite filter_type"
                defaultValue=""
                value={assigne_list_filter.status}
                onChange={(e) => {
                  this.customerAndStatusOnChange(e, 'status');

                }}
              >

                <Option value="">All</Option>
                <Option value="open-emailed">Open-Emailed</Option>
                <Option value="open-printed">Open-Printed</Option>
                <Option value="overdue">Overdue</Option>
                <Option value="paid">Paid</Option>
                <Option value="void">Void</Option>
              </Select>
            </div>
            <div className="fitem">
              <Select
                showSearch
                showArrow={false}
                filterOption={false}
                className="single_customer swhite filter_type"
                defaultValue=""
                suffixIcon={<i className="las la-search"></i>}

                onSearch={(e) => {
                  this.props.getCustomers({ q: e })
                }}
                onBlur={() => {
                  this.props.getCustomers({ limit: 10, offset: 0 })
                }}
                onChange={(e) => {
                  this.customerAndStatusOnChange(e, 'user__uuid');
                }}
              >
                <Option value="">All</Option>
                {map(customerList, (item) => {
                  return (
                    <Option key={item.uuid}>{item.first_name} {item.last_name}</Option>
                  )
                })}

              </Select>
            </div>

          </div>
        </div>
        <ul className="breadcrumb"><li onClick={() => { this.props.ChangeComponent(0) }}><span className="pointer"><i className="las la-angle-left"></i> Back to All Accounts</span></li></ul>

        <h2 style={{ 'padding': '0 25px 0 25px', 'margin': '0' }}>Accounts Receivable Aging Summary</h2>

        <div className="filter_wrapper acc-wrap flex bg-transparent" style={{ padding: '10px 25px 0 25px' }}>
          <div className="left_side mr-2">

            <Dropdown overlay={menu} trigger='click'>
              <button className="btn btn-warning" >Batch Actions <i className="las la-angle-down"></i></button>
            </Dropdown>
          </div>
          <div className="right_side">
            <div className="form-group flex ai-center w-100 flex-end">
              <div className="fitem fitem-rinner licon">
                <div className="fitem-ricon">
                  <i className="las la-search"></i>
                </div>
                <input
                  type="text"
                  onChange={(e) => this.onSearch(e)}
                  placeholder="Search acc number, customer address or contact details"
                  className="form-control flex-1"
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      this.onSearch({target: {value: this.state.search_value}})
                    }
                  }}
                />
              </div>
              <div className="fitem">
                <Select
                  className="swhite franchise_filter"
                  showSearch
                  showArrow={true}
                  suffixIcon={<i className="las la-angle-down"></i>}
                  defaultValue=""
                  disabled={this.props?.is_disable_franchise ? true : false}
                  onSearch={(e) => { this.props.getFranchiseList({ search: e }) }}
                  onBlur={() => { this.props.getFranchiseList({ limit: 10, offset: 0 }) }}
                  onChange={(e) => {
                    this.customerAndStatusOnChange(e, 'user__serviceorder__field_office__uuid');

                  }}
                >
                  <Option value="">All</Option>
                  {map(franchiseList, (item) => {
                    return (
                      <Option key={item.uuid}>{item.name}</Option>
                    )
                  })}
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className="block-row pt-10">
          {this.renderAggingSummaryTable()}
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default AccountAgingSummary;